export type McpDocumentDownload = {
  fileId: number;
  uniqueId?: number;
};

const consumedKeys = new Set<string>();

function queryParams(search: string): URLSearchParams {
  const raw = search.startsWith("?") ? search.slice(1) : search;
  return new URLSearchParams(raw);
}

export function parseMcpDownloadQuery(search: string): McpDocumentDownload | null {
  if (!search) {
    return null;
  }
  const params = queryParams(search);
  const fileId = Number(params.get("download"));
  if (!Number.isInteger(fileId) || fileId <= 0) {
    return null;
  }
  const uniqueRaw = params.get("uniqueId");
  if (uniqueRaw == null || uniqueRaw === "") {
    return { fileId };
  }
  const uniqueId = Number(uniqueRaw);
  if (!Number.isInteger(uniqueId) || uniqueId <= 0) {
    return { fileId };
  }
  return { fileId, uniqueId };
}

export function searchWithoutMcpDownload(search: string): string {
  const params = queryParams(search);
  params.delete("download");
  params.delete("uniqueId");
  const next = params.toString();
  return next ? `?${next}` : "";
}

export function takeMcpDownload(search: string): McpDocumentDownload | null {
  const parsed = parseMcpDownloadQuery(search);
  if (!parsed) {
    return null;
  }
  const key = `${parsed.fileId}:${parsed.uniqueId ?? ""}`;
  if (consumedKeys.has(key)) {
    return null;
  }
  consumedKeys.add(key);
  return parsed;
}

export function resetMcpDownloadGuardForTests() {
  consumedKeys.clear();
}
